/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadHorizontalPlus = createReactComponent(
  "device-ipad-horizontal-plus",
  "IconDeviceIpadHorizontalPlus",
  [
    [
      "path",
      {
        d: "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 17h3.5", key: "svg-1" }],
    ["path", { d: "M16 19h6", key: "svg-2" }],
    ["path", { d: "M19 16v6", key: "svg-3" }]
  ]
);

export { IconDeviceIpadHorizontalPlus as default };
//# sourceMappingURL=IconDeviceIpadHorizontalPlus.js.map
